// extracted by mini-css-extract-plugin
export default {"past":"index_past_BPqen","pastH":"index_pastH_Sx61H","passItem":"index_passItem_fFc-8"};